let isflag = false;
const activeslider = (boolean) => {
	if (boolean) {
		isflag = boolean;

		return boolean;
	}

	return isflag;
};

const videoPause = () => {
	$('.video').each((index, item) => {
		$(item).data('player').pause();
	});
};

const audioPause = () => {
	$('.player').each((index, elem) => {
		if (elem.dataset.player) {
			elem.dataset.player = 'pause';
			const audio = elem.querySelector('audio');
			audio.pause();
		}
	});
};

export {activeslider, videoPause, audioPause};
